.placeholder {
  /* Match the stage column dimensions */
  flex: 1;
  width: 90%;
  max-width: 90%;
  min-width: 90%;
  align-self: stretch;
  min-height: 20rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;

  padding: 1.6rem;
  border-radius: 0.8rem;
  background: var(--color-background-secondary);
  color: var(--color-texts-low-contrast);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  border: 1px solid transparent;

  svg {
    width: 2rem;
    height: 2rem;
  }

  &:hover {
    color: var(--color-texts-high-contrast);
    border-color: var(--color-texts-high-contrast);
  }

  @media (min-width: 768px) {
    width: 32rem;
    min-width: 32rem;
    max-width: 32rem;
  }
}
